import React from 'react';

import {
  useBeginTriageModalQuery,
  useSaveTriageObservationMutation
} from 'generated/graphql';

import * as types from './types';



export interface IReturnAuthorization {
  returnNumber: string;
  serialNumber: string;
  inventoryItemName: string;
  inventoryItemSku: string;
  referenceNumber: string;
  problemStatements: string[];
  customerComment: string;
}

export interface IData {
  returnAuthorization: IReturnAuthorization | null;
  formState: types.IFormState;
}

export function useQuery(returnAuthorizationId: string) {
  const tuple = useBeginTriageModalQuery({
    variables: {
      returnAuthorizationId
    }
  });

  return React.useMemo(
    () => {
      const returnAuthorization = tuple.data?.tier1ReturnAuthorization;
      const data: IData = {
        formState: {
          observedIssue: null,
          serialNumber: returnAuthorization?.itemReceipt?.serialNumber ?? ''
        },
        returnAuthorization: returnAuthorization ? {
          referenceNumber: returnAuthorization.group.referenceNumber,
          returnNumber: returnAuthorization.returnNumber,
          serialNumber: returnAuthorization.itemReceipt?.serialNumber ?? 'N/A',
          inventoryItemName: returnAuthorization.itemReceipt?.item.name ?? 'N/A',
          inventoryItemSku: returnAuthorization.itemReceipt?.item.sku ?? 'N/A',
          problemStatements: returnAuthorization.problemStatements,
          customerComment: returnAuthorization.customerComment
        } : null
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useTriageTier1ReturnAuthorization(returnAuthorizationId: string) {
  const [fnMutate, tuple] = useSaveTriageObservationMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (formState: types.IFormState) => {
      await fnMutate({
        variables: {
          input: {
            returnAuthorizationId,
            triageReasonId: formState.observedIssue?.id ?? ''
          }
        }
      });
    },
    [
      fnMutate,
      returnAuthorizationId
    ]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
